import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Router, Route, Switch, withRouter } from 'react-router-dom';
import ProtectedRoute from '../main/components/ProtectedRoute';
import { getCows } from '../cows/reducer';
import { fetchCows } from '../cows/actions';
import { fetchScores } from '../admin/scoreDefinitions/actions';
import PropTypes from 'prop-types';
import history from './beefbookHistory';
import loadable from '@loadable/component';
import Footer from '../main/components/Footer';
import BeefHoldingPage from '../content/holding/BeefHoldingPage';
import PrivacyPolicy from '../content/components/PrivacyPolicy';
import CollateralInfo from '../content/components/CollateralInfo';
import BBHomePage from './BBHomePage';
import './bb-styles.scss';
import BeefBookTerms from '../content/components/BeefBookTerms';

const Admin = loadable(() => import(
  /* webpackChunkName: "admin" */ '../admin/components/Admin'
));
const Notifications = loadable(() => import(
  /* webpackChunkName: "notifications" */
  '../notifications/components/Notifications'
));
const CowDetails = loadable(() => import(
  /* webpackChunkName: "cow-details" */ '../cows/components/CowDetails'
));
const Header = loadable(() => import(
  /* webpackChunkName: "header" */ '../header/components/Header'
));
const LoginPage = loadable(() => import(
  /* webpackChunkName: "login" */ '../main/components/LoginPage'
));
const Cows = loadable(() => import(
  /* webpackChunkName: "cows" */ '../cows/list/components/Cows'
));
const GoodBeef = loadable(() => import(
  /* webpackChunkName: "good-beef-section" */
  '../pages/goodbeef/components/Provider'
));
const BBAbout = loadable(() => import(
  /* webpackChunkName: "about" */ './about/BBAbout'
));

const PricingGuidelines = loadable(() => import(
  /* webpackChunkName: "pricing" */ './pricing/PricingGuidelines'
));

const mapStateToProps = state => ({
  cows: getCows(state)
});

const mapDispatchToProps = dispatch => ({
  fetchCows: () => dispatch(fetchCows()),
  fetchScoreDefs: () => dispatch(fetchScores())
});

class App extends Component {
  componentDidMount () {
    if (this.props.cows.length < 1) {
      this.props.fetchCows();
    }
    this.props.fetchScoreDefs();
  }
  render () {
    const HeaderWithRouter = withRouter(props => <Header { ...props} />);
    return (
      <Router history={history} >
        <div className="app-container" id="container">
          <HeaderWithRouter />
          <Notifications />
          <div id="content">
            <Switch>
              <Route exact path='/' render={
                props => <BBHomePage { ...props } /> } />
              <Route exact path="/cattle/:type" render={
                (props) => <Cows { ...props} /> } />
              <Route path="/cattle/:type/:cowId/:cowName"
                render={ (props) => <CowDetails { ...props } /> } />
              <Route path="/about" render={
                (props) => <BBAbout { ...props} /> } />
              <Route path="/privacy" render={
                (props) => <PrivacyPolicy { ...props} /> } />
              <Route path="/collateral-information" render={
                (props) => <CollateralInfo { ...props} /> } />
              <Route path="/good-beef" render={
                props => <GoodBeef { ...props } />
              } />
              <Route exact path='/login' render={
                (props) => <LoginPage { ...props} /> } />
              <ProtectedRoute path='/admin' render={
                (props) => <Admin { ...props } /> } />
              <Route exact path='/terms-and-conditions' render={
                (props) => <BeefBookTerms { ...props } /> } />
              <Route path='/pricing-guidelines' render={
                (props) => <PricingGuidelines { ...props } /> } />
              <Route exact path='/holding/beef' render={
                (props) => <BeefHoldingPage { ...props } /> } />
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
    );
  }
}

App.propTypes = {
  cows: PropTypes.array,
  fetchCows: PropTypes.func,
  fetchScoreDefs: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
